<template>
  <div
    class="duration-selector selector"
    :class="{ missing: !parseInt(classified.duration) && showWarnings }"
    id="duration-selector"
  >
    <div class="pa-block">
      <h3 class="selector-title">Planifiez la durée de votre annonce</h3>
      <div class="pa-block__inner pa-block__inner--flexbox">
        <div class="pa-block__row" v-if="classified.mode == 'print_web'">
          <!-- PRINT => weeks -->
          <select name="duration" id="duration" v-model="classified.duration">
            <option :value="null">Choisissez la durée de votre annonce</option>
            <option
              :value="idx + ' week'"
              v-for="idx in weekRange"
              v-bind:key="idx"
            >
              {{ idx }} semaine(s)
              <em
                v-if="durationDiscount(idx, classified) != 1"
                v-html="
                  '(-' +
                  Math.round((1 - durationDiscount(idx, classified)) * 100) +
                  '% de remise)'
                "
              ></em>
            </option>
          </select>
        </div>
        <!-- .pa-block__row -->
        <div
          class="pa-block__row"
          v-if="
            classified.mode == 'web' &&
            getCurrentCategory &&
            !getCurrentCategory.free_category
          "
        >
          <!-- WEB => months -->
          <select name="duration" id="duration" v-model="classified.duration">
            <option :value="null">Choisissez la durée de votre annonce</option>
            <option
              :value="idx + ' month'"
              v-for="idx in monthRange"
              v-bind:key="idx"
            >
              {{ idx }} mois
              <em
                v-if="durationDiscount(idx, classified) != 1"
                v-html="
                  '(-' +
                  Math.round((1 - durationDiscount(idx, classified)) * 100) +
                  '% de remise)'
                "
              ></em>
            </option>
          </select>
        </div>
        <!-- .pa-block__row -->

        <div
          class="pa-block__row"
          v-if="
            classified.mode == 'web' &&
            getCurrentCategory &&
            getCurrentCategory.free_category
          "
        >
          <input
            type="radio"
            name="duration"
            id="duration"
            value="1 month"
            v-model="classified.duration"
          />
          <label for="duration"> 1 mois </label>
        </div>
        <!-- .pa-block__row -->
        <div
          class="price"
          v-if="getPrice(classified, { with_membership_discount: false, include_diff_abcdent: false })"
        >
          <span>
            {{
              numberFormat(
                getPrice(classified, { with_membership_discount: false, include_diff_abcdent: false })
              )
            }}
            €
            <small>TTC</small>
          </span>
        </div>
        <!-- .price -->
        <div v-if="isAdmin">
          start_date:
          <datepicker v-model="start_date" :language="locale_fr"></datepicker>
          <br />
          end_date :
          <datepicker v-model="end_date" :language="locale_fr"></datepicker>
        </div>
        <div class="required" :if="!parseInt(classified.duration)">
          Champ non renseigné
        </div>
      </div>
      <!-- .pa-block__inner -->
    </div>
    <!-- .pa-block -->
  </div>
  <!-- .duration-selector -->
</template>
<script>
import { mapGetters, mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import { fr as locale_fr } from "vuejs-datepicker/dist/locale";
import { format, parse } from "date-fns";

export default {
  name: "duration-selector",
  components: {
    Datepicker,
  },
  props: {
    showWarnings: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return { locale_fr: locale_fr };
  },
  created() {
    if (!this.classified.duration && this.getPreset.duration)
      this.$store.commit("setDuration", this.getPreset.duration);
  },
  methods: {
    arrayRange(n) {
      let arr = [...Array(n).keys()];
      arr.shift();
      return arr;
    },
    parseDate(input) {
      // if (typeof input == "object") return input;
      if (!input) return;
      if (input.match(/\d{8}/)) return parse(input, "yyyyMMdd", new Date());
      return Date.parse(input);
    },
    formatDate(input) {
      const date =
        input.getFullYear() +
        "" +
        (input.getMonth() + 1) +
        "" +
        input.getDate();
      return date;
    },
  },
  computed: {
    ...mapState(["classified"]),
    ...mapGetters(["getCurrentCategory", "getPreset", "isAdmin", "isDev"]),
    weekRange() {
      return this.isAdmin ? this.arrayRange(52) : this.arrayRange(12);
    },
    monthRange() {
      return this.isAdmin ? this.arrayRange(12) : this.arrayRange(12);
    },
    // duration: {
    //   get() {
    //     return this.classified.duration;
    //   },
    //   set(duration) {
    //     this.$store.commit("setDuration", duration);
    //   }
    // },
    start_date: {
      get() {
        return this.parseDate(this.classified.start_date);
      },
      set(start_date) {
        this.$store.commit("setStartDate", format(start_date, "yyyyMMdd"));
      },
    },
    end_date: {
      get() {
        return this.parseDate(this.classified.end_date);
      },
      set(end_date) {
        this.$store.commit("setEndDate", format(end_date, "yyyyMMdd"));
      },
    },
  },
};
</script>
<style lang="scss">
.duration-selector .required {
  padding: 0.5rem 0 0 1rem;
}
</style>
